<div *ngIf="adschedule" provide-parent-form>
	<div class="field-group">
		<h3>{{ 'GENERAL' | translate }}</h3>
		<mat-form-field appearance="fill" class="full-width">
			<mat-label>{{'TITLE' | translate}}</mat-label>
			<input [(ngModel)]="adschedule.title" required type="text" name="adschedule_title"
				(ngModelChange)="onTitleUpdated(adschedule.title)" matInput />
		</mat-form-field>

		<mat-form-field appearance="fill" class="full-width">
			<mat-label>{{'CODE' | translate}}</mat-label>
			<input [readonly]="!!adschedule?.id" [(ngModel)]="adschedule.code" required type="text" name="adschedule_code"
				(ngModelChange)="updateCode(adschedule.code)" matInput />
		</mat-form-field>

		<mat-form-field appearance="fill" class="full-width pointer">
			<mat-label>{{ 'PLAYOUTS' | translate }}</mat-label>
		<bb-entity-selector theme="light-v2" [inMatFormField]="true" [(ngModel)]="adschedule.playoutCodes" name="adschedule_playoutCodes"
			[entityType]="'playout'" [multi]="true" [filterSet]="playoutFilterSet"></bb-entity-selector>
		</mat-form-field>
	</div>

	<h3 class="ad-breaks-title">{{ 'AD_BREAKS' | translate }}</h3>
	<div class="ad-positions">
		<div class="ad-position" *ngFor="let pos of adPositions">
			<div class="panel-toggle-button" (click)="pos.open = !pos.open" [class.open]="pos.open" [attr.data-cy]="'toggle-' + pos.title.toLowerCase()">
				<span class="title">{{ pos.title }}</span>
				<span class="description">{{ pos.description }}</span>
				<div class="toggle-icon">
					<i class="fa fa-chevron-right"></i>
					<i class="fa fa-chevron-down"></i>
				</div>
			</div>
			<div *ngIf="pos.open" class="content">
				<mat-divider [vertical]="true"></mat-divider>
				<div class="ad-position-container">
					<mat-form-field appearance="fill" class="full-width">
						<mat-label>{{ 'MINIMUM_CONTENT_LENGTH' | translate }}</mat-label>
						<bb-timecode-editor
							[inMatFormField]="true"
							[hideFrames]="true"
							[min]="0"
							[(ngModel)]="adschedule[pos.name].minimumContentLength"
							[name]="pos.name + '_minimum_content_length'"
							[matTooltip]="'HELP.AD_SCHEDULE_MINIMUM_CONTENT_LENGTH' | translate"
						></bb-timecode-editor>
					</mat-form-field>

					<div class="interval-wrapper" *ngIf="pos.name === 'midroll'">
						<mat-form-field appearance="fill" class="full-width">
							<mat-label>{{ 'INTERVAL' | translate }}</mat-label>
							<!-- Slightly odd to have two variant input elements here but this prevents expression changed errors & shows validation better compared to a dynamic [max] binding -->
							<input *ngIf="adschedule[pos.name].intervalUnit === 'seconds'" [(ngModel)]="adschedule[pos.name].interval" required type="number" name="midroll_interval" min="1" matInput [matTooltip]="'HELP.AD_SCHEDULE_INTERVAL' | translate"/>
							<input *ngIf="adschedule[pos.name].intervalUnit !== 'seconds'" [(ngModel)]="adschedule[pos.name].interval" required type="number" name="midroll_interval" min="1" max="99" matInput [matTooltip]="'HELP.AD_SCHEDULE_INTERVAL' | translate"/>
						</mat-form-field>
						<mat-form-field appearance="fill" class="full-width">
							<mat-label>{{ 'INTERVAL_UNIT' | translate }}</mat-label>
							<mat-select [(ngModel)]="adschedule[pos.name].intervalUnit" name="midroll_interval_unit" required>
								<mat-option value="seconds">{{ 'SECONDS' | translate }}</mat-option>
								<mat-option value="percent">{{ 'PERCENT' | translate }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>

					<bb-form-element [form]="form" [label]="'ALLOW_SKIPPING' | translate" class="center-toggle">
						<mat-slide-toggle [(ngModel)]="adschedule[pos.name].skippable"
							[name]="pos.name + '_skippable'">
						</mat-slide-toggle>
					</bb-form-element>

					<bb-form-element [form]="form" [label]="'USE_SCENE_ALIGNMENT' | translate" *ngIf="pos.name === 'midroll'">
						<mat-slide-toggle [(ngModel)]="adschedule[pos.name].useSceneAlignment" name="midroll_use_scene_alignment" [matTooltip]="'HELP.AD_SCHEDULE_USE_SCENE_ALIGNMENT' | translate"></mat-slide-toggle>	
					</bb-form-element>

					<div class="input" cdkDropList (cdkDropListDropped)="onVastItemDropped($event, pos.name)">
						<div class="drag-item" cdkDrag cdkDragLockAxis="y" cdkDragBoundary=".input"
							*ngFor="let item of adschedule[pos.name].items; let j = index; trackBy: trackByIndex">
							<div class="position-item">
								<div class="drag-handle">
									<i class="fa fa-bars"></i>
									<div class="drag-index"> {{ j + 1 }} </div>
								</div>
								<bb-form-element [form]="form" [required]="true" [hideLabel]="true"
									[actionButtonIcon]="'trash'" (actionButtonClick)="removePositionItem(pos.name, j)">
									<mat-form-field appearance="fill" class="full-width">
										<mat-label>{{ (item.vast_url !== undefined ? 'VAST_URL' : 'AUCTION') | translate }}</mat-label>
										<textarea *ngIf="item.vast_url !== undefined" rows="3" required [(ngModel)]="adschedule[pos.name].items[j].vast_url"
											[name]="pos.name + '_item_vast_url_' + (adschedule[pos.name].items[j]?.id || j)"
											(mousedown)="$event.stopPropagation()" [matTooltip]="'HELP.AD_SCHEDULE_VAST_URL' | translate" matInput></textarea>
										<bb-entity-selector
											*ngIf="item.auction_id !== undefined"
											[placeholder]="'ASSIGN_AUCTION' | translate"
											[excludedOptions]="assignedAuctionIds[pos.name]"
											[icon]="'gavel'"
											[disableClear]="true"
											[(ngModel)]="adschedule[pos.name].items[j].auction_id"
											[name]="pos.name + '_item_auction_id_' + (adschedule[pos.name].items[j]?.id || j)"
											(mousedown)="$event.stopPropagation()"
											(ngModelChange)="updateAssignedAuctions()"
											[entityType]="'auction'"></bb-entity-selector>
									</mat-form-field>
								</bb-form-element>
							</div>
						</div>
					</div>
					<div class="actions">
						<bb-button icon="plus" (click)="addVastUrl(pos.name)">
							{{ 'ADD_VAST_URL' | translate }}
						</bb-button>
						<bb-entity-selector [excludedOptions]="assignedAuctionIds[pos.name]" [placeholder]="'ASSIGN_AUCTION' | translate" [icon]="'chain'" [entityType]="'auction'" [selectOnly]="true" (optionSelected)="auctionSelected(pos.name, $event)" [ngModelOptions]="{standalone: true}" [excludedOptions]="assignedAuctionIds[pos.name]"></bb-entity-selector>
				</div>
			</div>
		</div>
	</div>
</div>
